<template>
<div class="masterReg">
    <vx-card>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2" style="margin-top:2%;margin-left:2%;">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Doctor Name</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" v-model="form.doctorName" name="DoctorName" v-validate="{ required: true,regex: /^[a-zA-Z .']+$/}" />
                        <span class="text-danger text-sm" v-show="errors.has('DoctorName')">{{ errors.first('DoctorName') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Doctor Degree</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" v-model="form.degree" name="DoctorDegree" v-validate="'required'" />
                        <span class="text-danger text-sm" v-show="errors.has('DoctorDegree')">{{ errors.first('DoctorDegree') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Address</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-textarea class="w-full" name="Address" v-model="form.address" v-validate="''" />
                        <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Phone No</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" v-validate="'numeric|min:10|max:10'" name="PhoneNumber" v-model="form.phoneNo" />
                        <span class="text-danger text-sm" v-show="errors.has('PhoneNumber')">{{ errors.first('PhoneNumber') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Clinic Name</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                            <select v-model="form.clinic" class=" vs-select--input myselect" style="height: 36px;" v-validate="'required'" name="ClinicName">
                                <option v-for="(item,index) in clinicList" v-bind:key="index" :value="item.companyId">{{item.companyName}}</option>
                            </select>
                        <!-- <vs-select class="selectExample w-full" name="ClinicName" v-model="form.clinic"  v-validate="'required'">
                            <vs-select-item :key="index" :value="item.companyId" :text="item.companyName" v-for="(item,index) in clinicList" />
                        </vs-select> -->
                        <span class="text-danger text-sm" v-show="errors.has('ClinicName')">{{ errors.first('ClinicName') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Department</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                            <select v-model="form.departmentId" class=" vs-select--input myselect" style="height: 36px;" v-validate="'required'" name="departments">
                                <option v-for="(item,index) in departmentList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                            </select>
                        <!-- <vs-select class="selectExample w-full" name="departments" v-model="form.departmentId" v-validate="'required'">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in departmentList" />
                        </vs-select> -->
                        <span class="text-danger text-sm" v-show="errors.has('departments')">{{ errors.first('departments') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>About Doctor</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-textarea class="w-full" v-model="form.about"  name="AboutDoctor" />
                    </div>
                </div>
                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>General Timing</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-textarea class="w-full" v-model="form.doctorTiming"  name="GeneralTiming" />
                    </div>
                </div>

            </div>
            <div class="vx-col w-full md:w-1/3" style="margin-top:3%;margin-right:2%;">
                <div class="vx-row mb-4">
                    <vs-checkbox v-model="form.status"><span>Active</span></vs-checkbox>
                </div>
                <div class="vx-row mb-6">
                    <div id="preview" class="mb-3">
                        <div v-if="!imageData" style="background:#a7a8a957;width:150px;height:150px;">
                        </div>
                        <img v-if="imageData" :src="imageData" width="150px;" height="150px;" />
                    </div>
                    <input name="File" type="file" id="File1" v-validate ="'image|mimes:jpg,jpeg'" ref="imageUrl" @change="onFileChange" />
                    <span class=" text-sm">SupportedType jpg/jpeg</span><br>
                    <span class="text-danger text-sm"  v-show="errors.has('File')">{{ errors.first('File') }}</span>

                    <!-- <input type="file" @change="onFileChange" /> -->
                </div>
               
                <div class="vx-row mb-3">
                    <!-- <ul>
                        <li><input type="checkbox" v-model="form.onlineBooking" id="checkbox1" /><label for="checkbox1">Online Booking</label></li>
                    </ul>
                    <ul>
                        <li><input type="checkbox" v-model="form.ivrsService" id="checkbox2" /><label for="checkbox2">IVRS Serviece</label></li>
                    </ul> -->
                    <vs-checkbox v-model="form.onlineBooking" tabindex="3"><span>Online Booking</span></vs-checkbox>
                    <vs-checkbox v-model="form.ivrsService" disabled><span>IVRS Serviece</span></vs-checkbox>
                </div>
                <div class="vx-row mb-4">
                    <vs-button color="primary" type="border" v-bind:disabled="saveFlag" style="margin-right:5px;margin-top:60%;" @click="saveDoctorReg">Save</vs-button>
                </div>
            </div>
        </div>
    </vx-card>
</div>
</template>

<script>
export default {
    name: 'doctorMasterReg',
    data() {
        return {
            form: {
                doctorId:"New",
                doctorName: "",
                degree: "",
                address: "",
                phoneNo: "",
                clinic:"",
                about: "",
                departmentId: "",
                onlineBooking: false,
                ivrsService: false,
                reportFile: "",
                status:true,
                doctorTiming:""
            },
            imageData: "",imageUrl:"",
            departmentList: [{
                id: "",
                name: "Select"
            }],
            clinicList: [{
                companyId: "",
                companyName: "Select"
            }],
            saveFlag: false
        }

    },
    watch: {
        '$route'() {
            if (this.$route.query.doctorId && this.$route.query.doctorId) {
                this.doctorId = this.$route.query.doctorId;
                 this.clinicId = this.$route.query.clinicId;
            } else {
                this.doctorId = 'New';
            }
            if (this.doctorId != 'New') {
                this.getDoctorDetails();
            }
        }
    },
    beforeMount() {
        if (this.$route.query.doctorId) {
            this.doctorId = this.$route.query.doctorId;
            this.clinicId = this.$route.query.clinicId;
        } else {
            this.doctorId = 'New';
        }

        if (this.doctorId != 'New') {
            this.getDoctorDetails();
        }
    },
    mounted() {
        this.getDepartmentList();
        this.getClinicList();
    },
    methods: {
        getClinicList() {
            this.$http.post("admin/getCliniclist",JSON.stringify(""), {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.$session.get('adminToken'),
                    "AdminUserID": this.$session.get('adminId')
                }
            })
            .then(response => {
                response.data.data.forEach((value) => {
                    this.clinicList.push(value);
                })
            })
        },
        getDepartmentList() {
            this.$http.post("admin/getdoctordepartments",JSON.stringify(""), {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.$session.get('adminToken'),
                    "AdminUserID": this.$session.get('adminId')
                }
            })
            .then(response => {
                response.data.data.forEach((value) => {
                    this.departmentList.push(value);
                })
            })
        },
        onFileChange(e) {
            var image='';
            const file = e.target.files[0];
            image = URL.createObjectURL(file);
            this.imageData= image;
            var input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.form.imageUrl = e.target.result;
                }
                reader.readAsDataURL(input.files[0]);
            }
            // var input = event.target;
            // if (input.files && input.files[0]) {
            //     var reader = new FileReader();
            //     reader.onload = (e) => {
            //         this.imageData = e.target.result;
            //         this.form.imageUrl = e.target.result;
            //     }
            //     reader.readAsDataURL(input.files[0]);
            // }
        },
        saveDoctorReg() {
         this.$validator.validateAll().then(valid => {
                if (valid) {
                    this.$vs.loading();
                    var request = {
                        companyId: parseInt(this.form.clinic),
                        data: this.form
                    };
                     this.saveFlag = true;
                    this.$http.post(
                            "admin/savedoctor",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": this.$session.get('adminToken'),
                                    "AdminUserID": this.$session.get('adminId')
                                }
                            }
                        )
                        .then(response => {
                            setTimeout( ()=> {
                                this.$vs.loading.close()
                            }, 300);
                            this.doctorId = response.data.data.doctorId;
                                this.$vs.notify({
                                    title: 'Saved Successfully',
                                    color: 'success',
                                    iconPack: 'feather',
                                    icon: 'icon-check',
                                    position: 'top-center'
                                });
                                if (!this.$route.query.doctorId) {
                                this.clearForm();
                                } else {
                                    this.$router.push({
                                        path: '/admin/doctorDashboard',
                                    })
                                }
                        }).catch(error => {
                            setTimeout( ()=> {
                                this.$vs.loading.close()
                            }, 300);
                        this.$vs.notify({
                            title: 'Error Occured While Saving',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-check',
                            position: 'top-center'
                        })
                        this.saveFlag = false;
                    })
                }
            });
        },
        clearForm() {
            this.form = {
                doctorId:"New",
                doctorName: "",
                degree: "",
                address: "",
                phoneNo: "",
                clinic:"",
                about: "",
                departmentId: "",
                onlineBooking: false,
                ivrsService: false,
                reportFile: "",
                status:true,
                doctorTiming:""
            }
            this.imageData="";
            // $("#File1").val('');
             this.$validator.reset();
            this.saveFlag=false;
        },
        getDoctorDetails() {
            this.$vs.loading();
                        var request = {
                companyId: this.clinicId,
                doctorId: this.doctorId
            };
            this.$http.post(
                    "admin/getDoctorDetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": this.$session.get('adminToken'),
                            "AdminUserID": this.$session.get('adminId')
                        }
                    }
                )
                .then(response => {
                    this.form = response.data.data;
                    this.imageData=response.data.data.imageUrl;
                    setTimeout( ()=> {
                        this.$vs.loading.close()
                    }, 300);
                    console.log(this.imageData);
                })
                
        }
    }
}
</script>

<style>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 300px;
}
</style>
